/* Sundazed theme — global behaviors */
(function () {
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  // Floating pill: show while scrolling, hide when idle
  // Skipped for full-width header (announcement would get covered by fixed top:0)
  (function initScrollAwareHeader() {
    if (!document.body.classList.contains('header-sticky-enabled')) return;
    var wrap = qs('[data-header-wrap]');
    if (!wrap || wrap.classList.contains('is-static')) return;
    if (wrap.classList.contains('header-wrap--full') || wrap.hasAttribute('data-header-full')) {
      wrap.classList.add('is-header-visible');
      return;
    }

    var IDLE_MS = 1100;
    var TOP_HIDE = 48;
    var TOP_SHOW = 96;
    var hideTimer = null;
    var lastY = window.scrollY || 0;
    var lastShowY = 0;
    var visible = false;
    var pinned = false;
    var ticking = false;

    function menuOpen() {
      var m = qs('[data-mobile-menu]');
      return !!(m && m.classList.contains('is-open'));
    }
    function cartOpen() {
      var c = qs('[data-cart-drawer]');
      return !!(c && c.classList.contains('is-open'));
    }
    function navDropdownOpen() {
      return !!qs('.header__dropdown[open]', wrap);
    }
    function shouldStayOpen() {
      return pinned || menuOpen() || cartOpen() || navDropdownOpen() || wrap.contains(document.activeElement);
    }

    function setVisible(next) {
      if (next === visible) return;
      visible = next;
      if (next) {
        wrap.classList.add('is-header-visible');
        document.body.classList.add('header-pill-open');
      } else {
        wrap.classList.remove('is-header-visible');
        document.body.classList.remove('header-pill-open');
      }
    }

    function show() {
      setVisible(true);
      lastShowY = window.scrollY || 0;
    }
    function hide() {
      if (shouldStayOpen()) return;
      setVisible(false);
    }

    function scheduleHide() {
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        hideTimer = null;
        hide();
      }, IDLE_MS);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var y = window.scrollY || window.pageYOffset || 0;
        if (y < 0) y = 0;
        var delta = y - lastY;

        // Top of page: always tuck away (clean PDP / hero)
        if (y <= TOP_HIDE && !shouldStayOpen()) {
          if (hideTimer) {
            clearTimeout(hideTimer);
            hideTimer = null;
          }
          setVisible(false);
          lastY = y;
          return;
        }

        // Only react to meaningful movement (ignore sub-pixel / rubber band noise)
        if (Math.abs(delta) < 3 && visible) {
          scheduleHide();
          lastY = y;
          return;
        }

        if (y >= TOP_SHOW) {
          show();
          scheduleHide();
        }

        lastY = y;
      });
    }

    wrap.addEventListener('mouseenter', function () {
      pinned = true;
      show();
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
    });
    wrap.addEventListener('mouseleave', function () {
      pinned = false;
      scheduleHide();
    });
    wrap.addEventListener('focusin', function () {
      pinned = true;
      show();
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
    });
    wrap.addEventListener('focusout', function () {
      setTimeout(function () {
        if (!wrap.contains(document.activeElement)) {
          pinned = false;
          scheduleHide();
        }
      }, 0);
    });

    var mo = qs('[data-mobile-menu]');
    var co = qs('[data-cart-drawer]');
    function watchDrawer(el) {
      if (!el || typeof MutationObserver === 'undefined') return;
      new MutationObserver(function () {
        if (menuOpen() || cartOpen()) {
          show();
          if (hideTimer) {
            clearTimeout(hideTimer);
            hideTimer = null;
          }
        } else {
          scheduleHide();
        }
      }).observe(el, { attributes: true, attributeFilter: ['class'] });
    }
    watchDrawer(mo);
    watchDrawer(co);

    window.addEventListener('scroll', onScroll, { passive: true });
    setVisible(false);
  })();

  function formatMoney(cents) {
    var amount = (Number(cents) || 0) / 100;
    var currency = (window.theme && window.theme.currency) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (e) {
      return currency + ' ' + amount.toFixed(2);
    }
  }

  function cartAddUrl() {
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    if (base.indexOf('.js') === -1) base = base + '.js';
    return base;
  }

  function cartChangeUrl() {
    var base = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
    if (base.indexOf('.js') === -1) base = base + '.js';
    return base;
  }

  // Mobile menu
  const menuOverlay = qs('[data-mobile-menu]');
  qsa('[data-open-menu]').forEach((btn) => {
    btn.addEventListener('click', () => menuOverlay && menuOverlay.classList.add('is-open'));
  });
  qsa('[data-close-menu]').forEach((btn) => {
    btn.addEventListener('click', () => menuOverlay && menuOverlay.classList.remove('is-open'));
  });
  if (menuOverlay) {
    menuOverlay.addEventListener('click', (e) => {
      if (e.target === menuOverlay) menuOverlay.classList.remove('is-open');
    });
  }

  // Desktop nav dropdowns — hover open with close delay (fixes submenu vanishing)
  (function initDesktopNavDropdowns() {
    var mq = window.matchMedia('(min-width: 900px) and (hover: hover)');
    var CLOSE_MS = 220;
    var closeTimers = new WeakMap();

    function isDesktopHover() {
      return mq.matches;
    }

    function closeAllExcept(keep) {
      qsa('.header__dropdown[open]').forEach(function (el) {
        if (el !== keep) el.removeAttribute('open');
      });
    }

    function cancelClose(details) {
      var t = closeTimers.get(details);
      if (t) {
        clearTimeout(t);
        closeTimers.delete(details);
      }
    }

    function scheduleClose(details) {
      cancelClose(details);
      var t = setTimeout(function () {
        details.removeAttribute('open');
        closeTimers.delete(details);
      }, CLOSE_MS);
      closeTimers.set(details, t);
    }

    qsa('.header__dropdown').forEach(function (details) {
      details.addEventListener('mouseenter', function () {
        if (!isDesktopHover()) return;
        cancelClose(details);
        closeAllExcept(details);
        details.setAttribute('open', '');
      });
      details.addEventListener('mouseleave', function () {
        if (!isDesktopHover()) return;
        scheduleClose(details);
      });
      // Moving into the panel still counts as inside details — also cancel if panel is entered
      var panel = details.querySelector('.header__dropdown-panel');
      if (panel) {
        panel.addEventListener('mouseenter', function () {
          if (!isDesktopHover()) return;
          cancelClose(details);
          details.setAttribute('open', '');
        });
      }
      details.addEventListener('toggle', function () {
        if (details.open) closeAllExcept(details);
      });
    });
  })();

  // Cart drawer
  const cartOverlay = qs('[data-cart-drawer]');

  function openCart() {
    if (cartOverlay) cartOverlay.classList.add('is-open');
  }
  function closeCart() {
    if (cartOverlay) cartOverlay.classList.remove('is-open');
  }

  /* —— ATC toast: “1 thing in your bag” —— */
  function ensureCartToast() {
    var el = qs('[data-cart-toast]');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'cart-toast';
    el.setAttribute('data-cart-toast', '');
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.hidden = true;
    el.innerHTML =
      '<div class="cart-toast__inner">' +
        '<span class="cart-toast__sun" aria-hidden="true">☀</span>' +
        '<div class="cart-toast__copy">' +
          '<p class="cart-toast__title" data-cart-toast-title></p>' +
          '<p class="cart-toast__sub" data-cart-toast-sub>cart is open on the side</p>' +
        '</div>' +
        '<button type="button" class="cart-toast__btn" data-cart-toast-open>view bag</button>' +
        '<button type="button" class="cart-toast__x" data-cart-toast-close aria-label="Dismiss">×</button>' +
      '</div>';
    document.body.appendChild(el);
    el.querySelector('[data-cart-toast-open]').addEventListener('click', function () {
      hideCartToast();
      openCart();
    });
    el.querySelector('[data-cart-toast-close]').addEventListener('click', hideCartToast);
    return el;
  }

  var cartToastTimer = null;
  function hideCartToast() {
    var el = qs('[data-cart-toast]');
    if (!el) return;
    el.classList.remove('is-visible');
    setTimeout(function () { el.hidden = true; }, 280);
    if (cartToastTimer) {
      clearTimeout(cartToastTimer);
      cartToastTimer = null;
    }
  }

  function showCartToast(itemCount) {
    var n = parseInt(itemCount, 10) || 0;
    if (n < 1) return;
    var el = ensureCartToast();
    var title = el.querySelector('[data-cart-toast-title]');
    if (title) {
      title.textContent = n === 1
        ? '1 thing in your bag'
        : n + ' things in your bag';
    }
    el.hidden = false;
    // reflow for animation
    void el.offsetWidth;
    el.classList.add('is-visible');
    if (cartToastTimer) clearTimeout(cartToastTimer);
    cartToastTimer = setTimeout(hideCartToast, 4200);
  }

  qsa('[data-open-cart]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      if (cartOverlay) {
        e.preventDefault();
        openCart();
        refreshCartUI(false);
      }
    });
  });
  // Event delegation so close always works (drawer re-renders body content)
  document.addEventListener('click', (e) => {
    var closeBtn = e.target.closest && e.target.closest('[data-close-cart]');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      closeCart();
      return;
    }
    if (cartOverlay && e.target === cartOverlay) {
      closeCart();
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      // Classic header shows "0 items"; only hide badge-style counters
      var isBadge = el.classList.contains('cart-count');
      if (isBadge) {
        if (count === 0) {
          el.setAttribute('hidden', 'hidden');
          el.hidden = true;
        } else {
          el.removeAttribute('hidden');
          el.hidden = false;
        }
      } else {
        el.removeAttribute('hidden');
        el.hidden = false;
      }
    });
    qsa('[data-cart-count-word]').forEach((el) => {
      el.textContent = count === 1 ? 'item' : 'items';
    });
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function volumeCfg() {
    var t = window.theme || {};
    return {
      enabled: t.volumeEnabled !== false,
      label: t.volumeLabel || 'Multi-piece savings',
      q1: parseInt(t.volumeQty1, 10) || 3,
      p1: parseInt(t.volumePct1, 10) || 3,
      q2: parseInt(t.volumeQty2, 10) || 4,
      p2: parseInt(t.volumePct2, 10) || 5,
      q3: parseInt(t.volumeQty3, 10) || 5,
      p3: parseInt(t.volumePct3, 10) || 10,
      step1: t.volumeStep1 || '3 · 3%',
      step2: t.volumeStep2 || '4 · 5%',
      step3: t.volumeStep3 || '5+ · 10%',
      msgNeedOne: t.volumeMsgNeedOne || 'Add 1 more piece for {pct}% off',
      msgNeedMany: t.volumeMsgNeedMany || 'Add {need} more pieces for {pct}% off',
      msgTier1: t.volumeMsgTier1 || '{pct}% unlocked · add 1 more for {next}% off',
      msgTier2: t.volumeMsgTier2 || '{pct}% unlocked · add 1 more for {next}% off',
      msgMax: t.volumeMsgMax || '{pct}% off unlocked — {qty}+ pieces'
    };
  }

  function volumeFill(tpl, vars) {
    var out = String(tpl || '');
    Object.keys(vars).forEach(function (k) {
      out = out.split('{' + k + '}').join(String(vars[k]));
    });
    return out;
  }

  function volumeDiscountHtml(itemCount) {
    var cfg = volumeCfg();
    if (!cfg.enabled) return '';
    var n = parseInt(itemCount, 10) || 0;
    var msg = '';
    var state = 'next';
    var pct = 0;
    var badge = '0%';
    var step1 = n >= cfg.q1;
    var step2 = n >= cfg.q2;
    var step3 = n >= cfg.q3;
    if (n < cfg.q1) {
      var need = cfg.q1 - n;
      msg = volumeFill(need === 1 ? cfg.msgNeedOne : cfg.msgNeedMany, {
        need: need,
        pct: cfg.p1,
        qty: cfg.q1,
        next: cfg.p1
      });
      state = 'next';
      pct = Math.min(55, Math.round((n / Math.max(cfg.q1, 1)) * 55));
    } else if (n < cfg.q2) {
      msg = volumeFill(cfg.msgTier1, { pct: cfg.p1, next: cfg.p2, qty: cfg.q1, need: 1 });
      state = 'mid';
      pct = 55;
      badge = cfg.p1 + '%';
    } else if (n < cfg.q3) {
      msg = volumeFill(cfg.msgTier2, { pct: cfg.p2, next: cfg.p3, qty: cfg.q2, need: 1 });
      state = 'mid';
      pct = 78;
      badge = cfg.p2 + '%';
    } else {
      msg = volumeFill(cfg.msgMax, { pct: cfg.p3, qty: cfg.q3, next: cfg.p3, need: 0 });
      state = 'max';
      pct = 100;
      badge = cfg.p3 + '%';
    }
    return (
      '<div class="cart-volume cart-volume--' + state + '" data-cart-volume>' +
        '<div class="cart-volume__head">' +
          '<span class="cart-volume__label">' + escapeHtml(cfg.label) + '</span>' +
          '<span class="cart-volume__pct" data-cart-volume-pct>' + escapeHtml(badge) + '</span>' +
        '</div>' +
        '<div class="cart-volume__track" role="progressbar" aria-valuemin="0" aria-valuemax="' + cfg.q3 + '" aria-valuenow="' + Math.min(n, cfg.q3) + '" aria-label="' + escapeHtml(cfg.label) + '">' +
          '<div class="cart-volume__fill" style="width:' + pct + '%"></div>' +
          '<div class="cart-volume__markers" aria-hidden="true">' +
            '<span class="cart-volume__mark' + (step1 ? ' is-on' : '') + '" style="left:55%"></span>' +
            '<span class="cart-volume__mark' + (step2 ? ' is-on' : '') + '" style="left:78%"></span>' +
            '<span class="cart-volume__mark' + (step3 ? ' is-on' : '') + '" style="left:100%"></span>' +
          '</div>' +
        '</div>' +
        '<div class="cart-volume__steps" aria-hidden="true">' +
          '<span class="cart-volume__step' + (step1 ? ' is-on' : '') + '">' + escapeHtml(cfg.step1) + '</span>' +
          '<span class="cart-volume__step' + (step2 ? ' is-on' : '') + '">' + escapeHtml(cfg.step2) + '</span>' +
          '<span class="cart-volume__step' + (step3 ? ' is-on' : '') + '">' + escapeHtml(cfg.step3) + '</span>' +
        '</div>' +
        '<p class="cart-volume__msg" data-cart-volume-msg>' + escapeHtml(msg) + '</p>' +
      '</div>'
    );
  }

  function cartUpsellShell(title, attrs) {
    return (
      '<div class="cart-upsell" ' + (attrs || '') + '>' +
        '<div class="cart-upsell__head">' +
          '<p class="cart-upsell__title">' + escapeHtml(title) + '</p>' +
          '<div class="cart-upsell__nav">' +
            '<button type="button" class="cart-upsell__nav-btn" data-cart-upsell-prev aria-label="Previous">' +
              '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.5 6.5L9 12l5.5 5.5"/></svg>' +
            '</button>' +
            '<button type="button" class="cart-upsell__nav-btn" data-cart-upsell-next aria-label="Next">' +
              '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9.5 6.5L15 12l-5.5 5.5"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-upsell__carousel" data-cart-upsell-carousel>' +
          '<div class="cart-upsell__track" data-cart-upsell-grid></div>' +
        '</div>' +
      '</div>'
    );
  }

  function initCartUpsellCarousel(root) {
    var shells = qsa('.cart-upsell', root || document);
    shells.forEach(function (shell) {
      var wrap = qs('[data-cart-upsell-carousel]', shell) || shell;
      var track = qs('[data-cart-upsell-grid]', shell) || qs('.cart-upsell__track', shell);
      if (!track) return;
      var cards = qsa('.cart-upsell__card', track);
      var prev = qs('[data-cart-upsell-prev]', shell);
      var next = qs('[data-cart-upsell-next]', shell);
      var nav = qs('.cart-upsell__nav', shell);

      function cardIndex() {
        var scroll = track.scrollLeft;
        var best = 0;
        var bestDist = Infinity;
        cards.forEach(function (card, i) {
          var dist = Math.abs(card.offsetLeft - scroll);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        });
        return best;
      }

      function scrollToIndex(i) {
        var card = cards[i];
        if (!card) return;
        track.scrollTo({ left: Math.max(0, card.offsetLeft - 4), behavior: 'smooth' });
      }

      function updateNav() {
        if (!prev && !next) return;
        var i = cardIndex();
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= cards.length - 1 || cards.length <= 1;
        if (nav) nav.hidden = cards.length <= 1;
      }

      if (prev) {
        prev.onclick = function () {
          scrollToIndex(Math.max(0, cardIndex() - 1));
        };
      }
      if (next) {
        next.onclick = function () {
          scrollToIndex(Math.min(cards.length - 1, cardIndex() + 1));
        };
      }

      if (!track._upsellScrollBound) {
        track._upsellScrollBound = true;
        var scrollTimer = null;
        track.addEventListener(
          'scroll',
          function () {
            if (scrollTimer) clearTimeout(scrollTimer);
            scrollTimer = setTimeout(updateNav, 40);
          },
          { passive: true }
        );
      }
      updateNav();
      wrap.setAttribute('data-carousel-ready', '1');
    });
  }

  function normalizePriceCents(p) {
    if (!p || p.price == null) return null;
    var price = p.price;
    if (typeof price === 'string') {
      if (price.indexOf('.') !== -1) return Math.round(parseFloat(price) * 100);
      return parseInt(price, 10);
    }
    // recommendations.json uses cents (e.g. 4500); products.json sometimes uses dollars as float
    if (typeof price === 'number' && price < 1000 && String(price).indexOf('.') !== -1) {
      return Math.round(price * 100);
    }
    return price;
  }

  function productCardMini(p, inCartIds) {
    if (!p || !p.id) return '';
    if (inCartIds && inCartIds[String(p.id)]) return '';
    var img = (p.featured_image || (p.images && p.images[0]) || '');
    if (img && typeof img === 'object') img = img.src || '';
    var url = p.url || ('/products/' + (p.handle || ''));
    var title = (p.title || '').toUpperCase();
    var cents = normalizePriceCents(p);
    var price = cents != null ? formatMoney(cents) : '';
    var variantId = p.variants && p.variants[0] ? p.variants[0].id : null;
    if (!variantId && p.variants && p.variants.length) variantId = p.variants[0].id;
    var available = p.available !== false && !(p.variants && p.variants[0] && p.variants[0].available === false);
    return (
      '<div class="cart-upsell__card">' +
        '<a class="cart-upsell__media" href="' + escapeHtml(url) + '" data-close-cart>' +
          (img
            ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy" width="96" height="120">'
            : '<div class="cart-upsell__ph"></div>') +
        '</a>' +
        '<div class="cart-upsell__meta">' +
          '<a class="cart-upsell__name" href="' + escapeHtml(url) + '" data-close-cart>' + escapeHtml(title) + '</a>' +
          (price ? '<span class="cart-upsell__price">' + price + '</span>' : '') +
          (available
            ? '<button type="button" class="cart-upsell__add" data-cart-upsell-add="' + escapeHtml(String(variantId)) + '">Add to cart</button>'
            : '<span class="cart-upsell__sold">Sold out</span>') +
        '</div>' +
      '</div>'
    );
  }

  function inCartProductMap(cart) {
    var map = {};
    (cart.items || []).forEach(function (it) {
      if (it.product_id) map[String(it.product_id)] = true;
    });
    return map;
  }

  function themeCartConfig() {
    var t = window.theme || {};
    return {
      emptyHandle: t.cartEmptyUpsellHandle || '',
      filledHandle: t.cartFilledUpsellHandle || '',
      emptyHeading: t.cartEmptyUpsellHeading || 'Add a little extra',
      filledHeading: t.cartFilledUpsellHeading || 'Add a little extra',
      useSmart: t.cartUseSmartRecs !== false,
      showFilled: t.cartShowFilledUpsell !== false,
      limit: Math.max(1, Math.min(8, parseInt(t.cartUpsellLimit, 10) || 4))
    };
  }

  async function fetchCollectionProducts(handle, limit) {
    if (!handle) return [];
    var url = '/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + (limit || 8);
    var res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) return [];
    var json = await res.json();
    return json.products || [];
  }

  async function fillCartUpsell(root, cart) {
    var grid = qs('[data-cart-upsell-grid]', root);
    if (!grid) return;
    var cfg = themeCartConfig();
    var inCart = inCartProductMap(cart || {});
    var products = [];
    var titleEl = qs('.cart-upsell__title', root);
    try {
      if (!cart || !cart.item_count) {
        if (titleEl) titleEl.textContent = cfg.emptyHeading;
        products = await fetchCollectionProducts(cfg.emptyHandle, cfg.limit + 4);
        if (!products.length) {
          products = await fetchCollectionProducts('all', cfg.limit + 4);
        }
      } else {
        if (!cfg.showFilled) {
          var filledShell = qs('[data-cart-upsell="filled"]', root);
          if (filledShell) filledShell.hidden = true;
          return;
        }
        if (titleEl) titleEl.textContent = cfg.filledHeading;
        if (cfg.filledHandle) {
          products = await fetchCollectionProducts(cfg.filledHandle, cfg.limit + 4);
        }
        if ((!products.length || !cfg.filledHandle) && cfg.useSmart) {
          var seed = cart.items[cart.items.length - 1];
          var pid = seed && seed.product_id;
          if (pid) {
            var intents = ['complementary', 'related'];
            for (var i = 0; i < intents.length && products.length < cfg.limit; i++) {
              var recRes = await fetch(
                '/recommendations/products.json?product_id=' + encodeURIComponent(pid) +
                '&limit=6&intent=' + intents[i],
                { headers: { Accept: 'application/json' } }
              );
              if (recRes.ok) {
                var recJson = await recRes.json();
                products = (recJson.products || []).concat(products);
              }
            }
          }
        }
        if (products.length < 2) {
          var fallbackHandle = cfg.filledHandle || cfg.emptyHandle || 'all';
          var more = await fetchCollectionProducts(fallbackHandle, cfg.limit + 4);
          products = products.concat(more);
        }
      }
    } catch (err) {
      console.error(err);
    }

    var seen = {};
    var html = '';
    var count = 0;
    products.forEach(function (p) {
      if (count >= cfg.limit) return;
      var id = String(p.id);
      if (seen[id] || inCart[id]) return;
      seen[id] = true;
      var card = productCardMini(p, inCart);
      if (card) {
        html += card;
        count++;
      }
    });
    grid.innerHTML = html || '<p class="cart-upsell__empty">Browse the shop to fill your bag.</p>';
    bindUpsellAdd(root);
    initCartUpsellCarousel(root);
  }

  function bindUpsellAdd(root) {
    qsa('[data-cart-upsell-add]', root).forEach(function (btn) {
      btn.addEventListener('click', async function () {
        var id = btn.getAttribute('data-cart-upsell-add');
        if (!id) return;
        btn.disabled = true;
        try {
          var res = await fetch(window.routes.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: Number(id), quantity: 1 })
          });
          if (!res.ok) throw new Error('add failed');
          await refreshCartUI(true, { toast: true });
        } catch (err) {
          console.error(err);
          btn.disabled = false;
        }
      });
    });
  }

  function renderCartDrawer(cart) {
    if (!cartOverlay) return;
    var body = qs('[data-cart-drawer-body]', cartOverlay);
    if (!body) return;

    var cfg = themeCartConfig();
    if (!cart || !cart.item_count) {
      body.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<div class="cart-drawer__empty-inner">' +
            '<p>Your bag is empty</p>' +
            '<a class="btn btn--cream" href="/collections/all" data-close-cart>Continue shopping</a>' +
          '</div>' +
          cartUpsellShell(cfg.emptyHeading, 'data-cart-upsell="empty"') +
        '</div>';
      bindDrawerClose(body);
      fillCartUpsell(body, cart);
      return;
    }

    var itemsHtml = cart.items.map(function (item) {
      var img = item.image
        ? '<a href="' + escapeHtml(item.url) + '"><img src="' + escapeHtml(item.image) + '" alt="" width="80" height="100" loading="lazy"></a>'
        : '<div></div>';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="cart-item__variant">' + escapeHtml(item.variant_title) + '</div>'
        : '';
      var propsHtml = '';
      var propPairs = [];
      var props = item.properties;
      if (props && !Array.isArray(props) && typeof props === 'object') {
        Object.keys(props).forEach(function (k) {
          propPairs.push([k, props[k]]);
        });
      } else if (Array.isArray(props)) {
        props.forEach(function (pair) {
          if (Array.isArray(pair) && pair.length >= 2) propPairs.push([pair[0], pair[1]]);
        });
      }
      propPairs = propPairs.filter(function (pair) {
        var k = pair[0];
        var v = pair[1];
        if (k == null || String(k).trim() === '' || String(k).charAt(0) === '_') return false;
        return v != null && String(v).trim() !== '';
      });
      if (propPairs.length) {
        propsHtml =
          '<div class="cart-item__props">' +
          propPairs
            .map(function (pair) {
              return (
                '<div class="cart-item__prop"><span class="cart-item__prop-k">' +
                escapeHtml(String(pair[0])) +
                ':</span> ' +
                escapeHtml(String(pair[1])) +
                '</div>'
              );
            })
            .join('') +
          '</div>';
      }
      return (
        '<div class="cart-item" data-cart-item-key="' + escapeHtml(item.key) + '">' +
          img +
          '<div>' +
            '<a class="cart-item__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
            variant +
            propsHtml +
            '<div class="cart-item__variant">Qty ' + item.quantity + '</div>' +
            '<button type="button" class="cart-item__remove" data-cart-remove="' + escapeHtml(item.key) + '">Remove</button>' +
          '</div>' +
          '<div>' + formatMoney(item.final_line_price) + '</div>' +
        '</div>'
      );
    }).join('');

    body.innerHTML =
      '<form action="/cart" method="post" id="CartDrawer-Form">' +
        '<div class="cart-drawer__items">' + itemsHtml + '</div>' +
        (cfg.showFilled ? cartUpsellShell(cfg.filledHeading, 'data-cart-upsell="filled"') : '') +
        '<div class="cart-drawer__footer">' +
          volumeDiscountHtml(cart.item_count) +
          '<div class="cart-drawer__subtotal">' +
            '<span>Subtotal</span>' +
            '<span data-cart-subtotal>' + formatMoney(cart.total_price) + '</span>' +
          '</div>' +
          '<p class="cart-drawer__note">Taxes and shipping calculated at checkout</p>' +
          '<button type="submit" class="btn btn--full" name="checkout">Checkout</button>' +
          '<a class="btn btn--cream btn--full mt-1" href="/cart" style="margin-top:0.75rem;">View full cart</a>' +
        '</div>' +
      '</form>';

    bindDrawerClose(body);
    bindCartRemove(body);
    fillCartUpsell(body, cart);
    initCartUpsellCarousel(body);
  }

  function bindDrawerClose(root) {
    qsa('[data-close-cart]', root).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        closeCart();
      });
    });
  }

  function bindCartRemove(root) {
    qsa('[data-cart-remove]', root).forEach((btn) => {
      btn.addEventListener('click', async function () {
        var key = btn.getAttribute('data-cart-remove');
        if (!key) return;
        try {
          var res = await fetch(cartChangeUrl(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          });
          if (!res.ok) throw new Error('Remove failed');
          var cart = await res.json();
          updateCartCount(cart.item_count || 0);
          renderCartDrawer(cart);
        } catch (err) {
          console.error(err);
        }
      });
    });
  }

  async function refreshCartUI(open, opts) {
    opts = opts || {};
    try {
      var cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!cartRes.ok) throw new Error('cart fetch failed');
      var cart = await cartRes.json();
      updateCartCount(cart.item_count || 0);
      renderCartDrawer(cart);
      if (open) openCart();
      if (opts.toast && cart.item_count > 0) {
        showCartToast(cart.item_count);
      }
      return cart;
    } catch (err) {
      console.error(err);
      return null;
    }
  }
  // Used by Build Your Bundle section (and any external ATC helpers)
  window.refreshCartUI = refreshCartUI;

  // Bind liquid-rendered empty-cart upsells + hydrate filled-cart recs
  if (cartOverlay) {
    bindUpsellAdd(cartOverlay);
    initCartUpsellCarousel(cartOverlay);
    var upsellHost = qs('[data-cart-upsell="filled"] [data-cart-upsell-grid]', cartOverlay);
    if (upsellHost && !upsellHost.children.length) {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (cart && cart.item_count) fillCartUpsell(cartOverlay, cart);
        })
        .catch(function () {});
    }
  }

  // Product rails
  qsa('[data-rail-btn]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const id = btn.getAttribute('data-rail-target');
      const dir = Number(btn.getAttribute('data-rail-dir') || 1);
      const rail = document.getElementById(id);
      if (rail) rail.scrollBy({ left: dir * 260, behavior: 'smooth' });
    });
  });

  // Quantity steppers
  qsa('[data-qty]').forEach((wrap) => {
    const input = qs('input', wrap);
    const minus = qs('[data-qty-minus]', wrap);
    const plus = qs('[data-qty-plus]', wrap);
    if (!input) return;
    if (minus) {
      minus.addEventListener('click', () => {
        const v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (plus) {
      plus.addEventListener('click', () => {
        const v = (parseInt(input.value, 10) || 1) + 1;
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });

  // Product media thumbs
  qsa('[data-product-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const src = thumb.getAttribute('data-full-src');
      const main = qs('[data-product-main-image]');
      if (main && src) {
        main.src = src;
        qsa('[data-product-thumb]').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      }
    });
  });

  // Variant select -> update price / availability / id
  qsa('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      const form = select.closest('form');
      const idInput = form && qs('[name="id"]', form);
      if (idInput) idInput.value = option.value;

      const priceEl = qs('[data-product-price]');
      if (priceEl && option.dataset.price) priceEl.innerHTML = option.dataset.price;

      const btn = form && qs('[type="submit"]', form);
      if (btn) {
        const available = option.dataset.available === 'true';
        btn.disabled = !available;
        btn.textContent = available
          ? (btn.dataset.addLabel || 'Add to cart')
          : (btn.dataset.soldLabel || 'Sold out');
      }
    });
  });

  function setQuickAtcLabel(atc, available) {
    if (!atc) return;
    var sold = atc.getAttribute('data-sold-label') || 'Sold out';
    var desk = atc.getAttribute('data-add-label') || 'Add to bag';
    var mob = atc.getAttribute('data-add-label-mobile') || desk;
    if (!available) {
      atc.textContent = sold;
      return;
    }
    atc.innerHTML =
      '<span class="product-card__atc-label product-card__atc-label--desk"></span>' +
      '<span class="product-card__atc-label product-card__atc-label--mob"></span>';
    var d = atc.querySelector('.product-card__atc-label--desk');
    var m = atc.querySelector('.product-card__atc-label--mob');
    if (d) d.textContent = desk;
    if (m) m.textContent = mob;
  }

  // Collection / card quick-add: size dropdown
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('[data-quick-select], select.product-card__select')) return;
    var form = sel.closest('form[data-product-form], .product-card__quick');
    if (!form) return;
    var atc = form.querySelector('[data-quick-atc], button[type="submit"]');
    var hint = form.querySelector('[data-quick-hint]');
    var opt = sel.options[sel.selectedIndex];
    var available = true;
    if (opt) {
      if (opt.disabled) available = false;
      if (opt.getAttribute('data-available') === 'false') available = false;
      if (!opt.value) available = false;
    } else {
      available = false;
    }
    if (hint) hint.hidden = !!sel.value;
    if (atc) {
      atc.disabled = !available;
      setQuickAtcLabel(atc, available);
    }
  });

  // Collection / card quick-add: size pills
  document.addEventListener('click', function (e) {
    var pill = e.target && e.target.closest && e.target.closest('[data-quick-pill]');
    if (!pill || pill.disabled) return;
    var form = pill.closest('form[data-product-form], .product-card__quick');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('[data-quick-pills-input], input[name="id"][data-quick-variant-id]');
    var atc = form.querySelector('[data-quick-atc], button[type="submit"]');
    var hint = form.querySelector('[data-quick-hint]');
    var id = pill.getAttribute('data-variant-id');
    var available = pill.getAttribute('data-available') !== 'false';
    form.querySelectorAll('[data-quick-pill]').forEach(function (p) {
      p.classList.toggle('is-selected', p === pill);
      p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
    });
    if (input && id) input.value = id;
    if (hint) hint.hidden = true;
    if (atc) {
      atc.disabled = !available;
      setQuickAtcLabel(atc, available);
    }
  });

  // Ajax add to cart (PDP + collection cards) — event delegation
  document.addEventListener('submit', async function (e) {
    var form = e.target;
    if (!form || !form.matches) return;
    if (!form.matches('form[data-product-form], form.pdp__form, form.product-card__quick')) return;

    var useAjax =
      form.getAttribute('data-ajax') === 'true' ||
      form.hasAttribute('data-ajax') ||
      (window.theme && window.theme.cartType === 'drawer') ||
      !!cartOverlay;

    if (!useAjax) return;

    e.preventDefault();
    e.stopPropagation();

    var idInput = form.querySelector('input[name="id"]');
    if (idInput && !idInput.value) {
      var hint = form.querySelector('[data-quick-hint]');
      if (hint) {
        hint.hidden = false;
      } else {
        alert('Please choose a size');
      }
      return;
    }

    // Multi-variant: require a real selection from the dropdown
    var quickSelect = form.querySelector('[data-quick-select], select.product-card__select');
    if (quickSelect) {
      if (!quickSelect.value) {
        var h = form.querySelector('[data-quick-hint]');
        if (h) h.hidden = false;
        quickSelect.focus();
        return;
      }
      var opt = quickSelect.options[quickSelect.selectedIndex];
      if (opt && (opt.disabled || opt.getAttribute('data-available') === 'false')) return;
    }

    var submitBtn = form.querySelector('[type="submit"][name="add"], button[type="submit"]');
    var stickyBtn = form.closest('.pdp, [data-product-form-root]')
      ? document.querySelector('[data-sticky-atc-btn]')
      : null;
    var isCardAtc = !!(submitBtn && submitBtn.matches('[data-quick-atc]'));
    var originalLabel = submitBtn ? submitBtn.textContent : '';
    var originalSticky = stickyBtn ? stickyBtn.textContent : '';
    var originalCardHtml = isCardAtc ? submitBtn.innerHTML : '';

    function setBusy(busy, label) {
      if (submitBtn) {
        submitBtn.disabled = busy;
        if (label) {
          submitBtn.textContent = label;
        } else if (!busy) {
          if (isCardAtc && originalCardHtml) submitBtn.innerHTML = originalCardHtml;
          else submitBtn.textContent = originalLabel;
        }
      }
      if (stickyBtn) {
        stickyBtn.disabled = busy;
        if (label) stickyBtn.textContent = label;
        else if (!busy) stickyBtn.textContent = originalSticky;
      }
    }

    setBusy(true, 'Adding…');
    var fd = new FormData(form);

    try {
      var res = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: fd
      });

      var data = null;
      try { data = await res.json(); } catch (_) {}

      if (!res.ok) {
        var msg = (data && (data.description || data.message)) || 'Could not add to cart';
        throw new Error(msg);
      }

      var cart = await refreshCartUI(true, { toast: true });

      // Bundle / AOV offer from merchant-set collection
      if (cart && typeof window.__sundazedShowBundleOffer === 'function') {
        setTimeout(function () {
          window.__sundazedShowBundleOffer(cart);
        }, 350);
      }

      setBusy(false, 'Added ✓');
      setTimeout(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          if (isCardAtc) setQuickAtcLabel(submitBtn, true);
          else submitBtn.textContent = originalLabel;
        }
        if (stickyBtn) {
          stickyBtn.disabled = false;
          stickyBtn.textContent = originalSticky;
        }
      }, 1200);
    } catch (err) {
      console.error(err);
      setBusy(false);
      alert(err.message || 'Could not add to cart. Please try again.');
    }
  });

  // Cart page: remove line via × / Remove (AJAX, no stuck button)
  document.addEventListener('click', async function (e) {
    var rm = e.target.closest && e.target.closest('[data-cart-page-remove]');
    if (!rm) return;
    e.preventDefault();
    e.stopPropagation();
    var key = rm.getAttribute('data-cart-page-remove');
    if (!key) return;
    rm.disabled = true;
    try {
      var res = await fetch(cartChangeUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      if (!res.ok) throw new Error('Remove failed');
      // Reload cart page so totals/lines stay correct
      window.location.reload();
    } catch (err) {
      console.error(err);
      rm.disabled = false;
      alert('Could not remove item. Please try again.');
    }
  });

  // Hero ornament — scroll-linked rotate + parallax
  (function () {
    const orn = qs('[data-hero-ornament]');
    if (!orn) return;
    const target = orn.querySelector('img') || orn;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const pSpeed = Number(orn.getAttribute('data-parallax-speed') || 45) / 100;
    const rSpeed = Number(orn.getAttribute('data-rotate-speed') || 10) / 100;

    let ticking = false;
    function update() {
      const y = window.scrollY || window.pageYOffset;
      target.style.transform = 'translate3d(0,' + (y * pSpeed) + 'px,0) rotate(' + (y * rSpeed) + 'deg)';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  })();

  // Open cart from query
  if (window.location.search.indexOf('cart=open') !== -1) {
    refreshCartUI(true);
  }

  /* —— Search drawer (right panel + predictive) —— */
  (function initPredictiveSearch() {
    var drawer = qs('[data-header-search-drawer]') || qs('[data-header-search]');
    var toggle = qs('[data-search-toggle]');
    if (!drawer || !toggle) return;

    var panel = qs('[data-search-panel]', drawer);
    var backdrop = qs('[data-search-backdrop]', drawer);
    var input = qs('[data-search-input]', drawer);
    var results = qs('[data-search-results]', drawer);
    var idle = qs('[data-search-idle]', drawer);
    var form = qs('[data-search-form]', drawer);
    var clearBtn = qs('[data-search-clear]', drawer);
    var closeBtns = qsa('[data-search-close]', drawer);
    var popularBtns = qsa('[data-search-popular]', drawer);
    var timer = null;
    var lastQ = '';
    var isOpen = false;

    function money(cents) {
      try { return formatMoney(cents); } catch (e) { return ''; }
    }

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function showIdle() {
      if (idle) idle.hidden = false;
      if (results) {
        results.hidden = true;
        results.innerHTML = '';
      }
    }

    function showResultsMode() {
      if (idle) idle.hidden = true;
      if (results) results.hidden = false;
    }

    function syncClear() {
      if (!clearBtn || !input) return;
      clearBtn.hidden = !input.value;
    }

    function openSearch() {
      isOpen = true;
      drawer.hidden = false;
      // reflow for animation
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('search-open');
      setTimeout(function () { if (input) input.focus(); }, 80);
    }

    function closeSearch() {
      isOpen = false;
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('search-open');
      setTimeout(function () {
        if (!isOpen) drawer.hidden = true;
      }, 320);
    }

    function renderEmpty(msg) {
      showResultsMode();
      results.innerHTML = '<p class="search-drawer__empty">' + esc(msg) + '</p>';
    }

    function renderProducts(products, q) {
      showResultsMode();
      if (!products || !products.length) {
        renderEmpty('No matches for “' + q + '”');
        return;
      }
      var html = products.map(function (p) {
        var img = p.image || p.featured_image || '';
        if (img && typeof img === 'object') img = img.url || img.src || '';
        var url = p.url || ('/products/' + (p.handle || ''));
        var price = '';
        if (p.price != null) {
          var cents = p.price;
          if (typeof cents === 'string') {
            cents = cents.indexOf('.') !== -1 ? Math.round(parseFloat(cents) * 100) : parseInt(cents, 10);
          }
          price = money(cents);
        }
        return (
          '<a class="search-drawer__item" href="' + esc(url) + '" role="option" data-search-close>' +
            (img
              ? '<img src="' + esc(img) + '" alt="" width="56" height="56" loading="lazy">'
              : '<span class="search-drawer__ph">☀</span>') +
            '<span class="search-drawer__item-title">' + esc(p.title || '') + '</span>' +
            (price ? '<span class="search-drawer__item-price">' + price + '</span>' : '') +
          '</a>'
        );
      }).join('');
      html += '<a class="search-drawer__see-all" href="/search?q=' + encodeURIComponent(q) + '">see all results</a>';
      results.innerHTML = html;
    }

    async function runSuggest(q) {
      q = (q || '').trim();
      syncClear();
      if (q.length < 2) {
        lastQ = '';
        showIdle();
        return;
      }
      if (q === lastQ) return;
      lastQ = q;
      showResultsMode();
      results.innerHTML = '<p class="search-drawer__loading">searching…</p>';

      var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
      var url = base;
      if (url.indexOf('.json') === -1) url = url.replace(/\/?$/, '') + '.json';
      url += (url.indexOf('?') === -1 ? '?' : '&') +
        'q=' + encodeURIComponent(q) +
        '&resources[type]=product' +
        '&resources[limit]=8' +
        '&resources[options][unavailable_products]=last';

      try {
        var res = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('suggest failed');
        var data = await res.json();
        var products =
          (data.resources && data.resources.results && data.resources.results.products) ||
          (data.resources && data.resources.products) ||
          data.products ||
          [];
        products = products.map(function (p) {
          return {
            title: p.title,
            url: p.url,
            handle: p.handle,
            image: p.image || p.featured_image ||
              (p.featured_media && p.featured_media.preview_image && p.featured_media.preview_image.src),
            price: p.price != null ? p.price : (p.price_min != null ? p.price_min : null)
          };
        });
        renderProducts(products, q);
      } catch (err) {
        console.error(err);
        try {
          var alt = '/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=8';
          var res2 = await fetch(alt, { headers: { Accept: 'application/json' } });
          if (res2.ok) {
            var data2 = await res2.json();
            var products2 =
              (data2.resources && data2.resources.results && data2.resources.results.products) || [];
            renderProducts(products2.map(function (p) {
              return { title: p.title, url: p.url, image: p.image, price: p.price };
            }), q);
            return;
          }
        } catch (e2) {}
        renderEmpty('Couldn’t search right now — try again');
      }
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (isOpen) closeSearch();
      else openSearch();
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeSearch();
      });
    });
    if (backdrop) backdrop.addEventListener('click', closeSearch);

    document.addEventListener('click', function (e) {
      var closeHit = e.target.closest && e.target.closest('[data-search-close]');
      if (closeHit && drawer.contains(closeHit) && closeHit.tagName === 'A') {
        // let navigation happen, just close drawer state
        closeSearch();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) closeSearch();
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (input) {
          input.value = '';
          input.focus();
        }
        lastQ = '';
        syncClear();
        showIdle();
      });
    }

    popularBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var term = btn.getAttribute('data-search-popular') || '';
        if (!input) return;
        input.value = term;
        syncClear();
        lastQ = '';
        runSuggest(term);
      });
    });

    if (input) {
      input.addEventListener('input', function () {
        var q = input.value;
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () { runSuggest(q); }, 200);
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = (input && input.value || '').trim();
        if (q.length < 2) return;
        // Prefer first product result; otherwise stay in drawer
        var first = results && !results.hidden && results.querySelector('.search-drawer__item');
        if (first) {
          first.click();
          return;
        }
        lastQ = '';
        runSuggest(q);
      });
    }
  })();

  /* —— Sun cursor: ONLY while claim-reward popup is open —— */
  (function initSunCursor() {
    if (!window.theme || window.theme.sunCursor === false) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;

    var cursor = qs('[data-sun-cursor]');
    if (!cursor) return;

    var x = 0, y = 0, tx = 0, ty = 0, raf = null;
    var active = false;

    function isPopupOpen() {
      return document.body.classList.contains('claim-reward-open');
    }

    function setCursorMode(on) {
      if (on === active) return;
      active = on;
      if (on) {
        document.documentElement.classList.add('sun-cursor-on');
        cursor.classList.add('is-on');
      } else {
        document.documentElement.classList.remove('sun-cursor-on');
        cursor.classList.remove('is-on', 'is-down');
      }
    }

    function loop() {
      if (!active) {
        raf = null;
        return;
      }
      x += (tx - x) * 0.28;
      y += (ty - y) * 0.28;
      cursor.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
      raf = requestAnimationFrame(loop);
    }

    window.addEventListener('mousemove', function (e) {
      if (!isPopupOpen()) {
        setCursorMode(false);
        return;
      }
      setCursorMode(true);
      tx = e.clientX;
      ty = e.clientY;
      if (!raf) raf = requestAnimationFrame(loop);
    }, { passive: true });

    window.addEventListener('mousedown', function () {
      if (active) cursor.classList.add('is-down');
    });
    window.addEventListener('mouseup', function () {
      cursor.classList.remove('is-down');
    });

    // Watch body class toggles from claim-reward section
    var mo = new MutationObserver(function () {
      if (!isPopupOpen()) setCursorMode(false);
    });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  })();

  /* —— Post-ATC bundle offer (merchant-set collection) —— */
  (function initBundleOffer() {
    function cfg() {
      var t = window.theme || {};
      return {
        handle: t.cartFilledUpsellHandle || '',
        heading: t.bundleOfferHeading || t.cartFilledUpsellHeading || 'add this too?',
        sub: t.bundleOfferSub || 'pair it up — little extras that love company',
        limit: Math.max(1, Math.min(6, parseInt(t.cartUpsellLimit, 10) || 4)),
        enabled: t.bundleOfferEnabled !== false
      };
    }

    function ensureModal() {
      var el = qs('[data-bundle-offer]');
      if (el) return el;
      el = document.createElement('div');
      el.className = 'bundle-offer';
      el.setAttribute('data-bundle-offer', '');
      el.hidden = true;
      el.innerHTML =
        '<div class="bundle-offer__backdrop" data-bundle-close tabindex="-1"></div>' +
        '<div class="bundle-offer__panel" role="dialog" aria-modal="true" aria-labelledby="BundleOfferTitle">' +
          '<button type="button" class="bundle-offer__x" data-bundle-close aria-label="Close">×</button>' +
          '<p class="bundle-offer__eyebrow">you just added something nice</p>' +
          '<h2 id="BundleOfferTitle" class="bundle-offer__title" data-bundle-title></h2>' +
          '<p class="bundle-offer__sub" data-bundle-sub></p>' +
          '<div class="bundle-offer__grid" data-bundle-grid></div>' +
          '<div class="bundle-offer__actions">' +
            '<button type="button" class="btn" data-bundle-view-cart>view bag</button>' +
            '<button type="button" class="bundle-offer__skip" data-bundle-close>no thanks, keep shopping</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(el);

      el.querySelectorAll('[data-bundle-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { hideBundleOffer(); });
      });
      el.querySelector('[data-bundle-view-cart]').addEventListener('click', function () {
        hideBundleOffer();
        openCart();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !el.hidden) hideBundleOffer();
      });
      return el;
    }

    function hideBundleOffer() {
      var el = qs('[data-bundle-offer]');
      if (!el) return;
      el.hidden = true;
      document.body.classList.remove('bundle-offer-open');
    }

    function moneyFromProduct(p) {
      var cents = null;
      if (p.price != null) {
        if (typeof p.price === 'string' && p.price.indexOf('.') !== -1) {
          cents = Math.round(parseFloat(p.price) * 100);
        } else {
          cents = Number(p.price);
        }
      }
      return cents != null ? formatMoney(cents) : '';
    }

    async function showBundleOffer(cart) {
      var c = cfg();
      if (!c.enabled || !c.handle) return;
      var el = ensureModal();
      var title = el.querySelector('[data-bundle-title]');
      var sub = el.querySelector('[data-bundle-sub]');
      var grid = el.querySelector('[data-bundle-grid]');
      if (title) title.textContent = c.heading;
      if (sub) sub.textContent = c.sub;
      grid.innerHTML = '<p class="bundle-offer__loading">loading ideas…</p>';

      el.hidden = false;
      document.body.classList.add('bundle-offer-open');

      var inCart = {};
      (cart.items || []).forEach(function (it) {
        if (it.product_id) inCart[String(it.product_id)] = true;
      });

      var products = [];
      try {
        var res = await fetch(
          '/collections/' + encodeURIComponent(c.handle) + '/products.json?limit=' + (c.limit + 6),
          { headers: { Accept: 'application/json' } }
        );
        if (res.ok) {
          var json = await res.json();
          products = json.products || [];
        }
      } catch (err) {
        console.error(err);
      }

      var html = '';
      var count = 0;
      products.forEach(function (p) {
        if (count >= c.limit) return;
        if (inCart[String(p.id)]) return;
        var img = p.featured_image || (p.images && p.images[0]) || '';
        if (img && typeof img === 'object') img = img.src || '';
        var url = p.url || ('/products/' + (p.handle || ''));
        var variantId = p.variants && p.variants[0] ? p.variants[0].id : null;
        var available = p.available !== false && !(p.variants && p.variants[0] && p.variants[0].available === false);
        if (!variantId || !available) return;
        html +=
          '<div class="bundle-offer__card">' +
            '<a class="bundle-offer__media" href="' + escapeHtml(url) + '">' +
              (img
                ? '<img src="' + escapeHtml(img) + '" alt="" width="200" height="200" loading="lazy">'
                : '<span class="bundle-offer__ph"></span>') +
            '</a>' +
            '<a class="bundle-offer__name" href="' + escapeHtml(url) + '">' + escapeHtml(p.title || '') + '</a>' +
            '<span class="bundle-offer__price">' + moneyFromProduct(p) + '</span>' +
            '<button type="button" class="btn bundle-offer__add" data-bundle-add="' + escapeHtml(String(variantId)) + '">add</button>' +
          '</div>';
        count++;
      });

      if (!html) {
        grid.innerHTML = '<p class="bundle-offer__empty">nothing extra right now — you’re good.</p>';
        return;
      }
      grid.innerHTML = html;

      grid.querySelectorAll('[data-bundle-add]').forEach(function (btn) {
        btn.addEventListener('click', async function () {
          var id = btn.getAttribute('data-bundle-add');
          if (!id) return;
          btn.disabled = true;
          btn.textContent = 'adding…';
          try {
            var res = await fetch(cartAddUrl(), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: Number(id), quantity: 1 })
            });
            if (!res.ok) throw new Error('add failed');
            btn.textContent = 'added ✓';
            var cart = await refreshCartUI(true, { toast: true });
            // refresh cards excluding newly added
            setTimeout(function () {
              if (cart) showBundleOffer(cart);
            }, 500);
          } catch (err) {
            console.error(err);
            btn.disabled = false;
            btn.textContent = 'add';
          }
        });
      });
    }

    // Expose for ATC handler
    window.__sundazedShowBundleOffer = showBundleOffer;
  })();
})();
